import api from 'api/api'
import { toast } from 'react-toastify'

export const GET_SORTS_WITH_SUBSORTS = '[SORTS] GET SORTS WITH SUBSORTS'
export const SAVE_SORT = '[SORTS] SAVE SORT'
export const TOGGLE_SORT_STATUS = '[SORTS] TOGGLE SORT STATUS'
export const DELETE_SORT = '[SORTS] DELETE SORT'
export const UPDATE_SORT_WITH_SUBSORTS = '[SORTS] UPDATE SORT WITH SUBSORTS'

export function getSortsWithSubsortsAction() {
  const request = api.get(`/sorts/with-subsorts`)
  return (dispatch) => {
    dispatch({ type: GET_SORTS_WITH_SUBSORTS, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_SORTS_WITH_SUBSORTS, payload: { loading: false, data: response.data.data } })
    }).catch((error) => {
      console.log(GET_SORTS_WITH_SUBSORTS, error)
    }).finally(() => {
      dispatch({ type: GET_SORTS_WITH_SUBSORTS, payload: { loading: false } })
    })
  }
}

export function saveSortAction(data) {
  const request = api.post(`/sorts/save`, data)
  return (dispatch) => {
    dispatch({ type: SAVE_SORT, payload: { saving: true } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: SAVE_SORT, payload: { saved: true, data: response.data.data } })
    }).catch((error) => {
      console.log(SAVE_SORT, error)
    }).finally(() => {
      dispatch({ type: SAVE_SORT, payload: { saving: false } })
    })
  }
}

export function toggleSortStatusAction(sortId) {
  const request = api.put(`/sorts/${sortId}/toggle-status`)
  return (dispatch) => {
    dispatch({ type: TOGGLE_SORT_STATUS, payload: { updating_id: sortId } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: TOGGLE_SORT_STATUS, payload: { data: response.data.data } })
    }).catch((error) => {
      console.log(TOGGLE_SORT_STATUS, error)
    }).finally(() => {
      dispatch({ type: TOGGLE_SORT_STATUS, payload: { updating_id: sortId } })
    })
  }
}

export function deleteSortAction(sortId) {
  const request = api.delete(`/sorts/${sortId}/delete`)
  return (dispatch) => {
    dispatch({ type: DELETE_SORT, payload: { deleting: true } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: DELETE_SORT, payload: { deleted: true, deleted_id: sortId } })
    }).catch((error) => {
      console.log(DELETE_SORT, error)
    }).finally(() => {
      dispatch({ type: DELETE_SORT, payload: { deleting: false } })
    })
  }
}